import { render, staticRenderFns } from "./BusinessRegulations-Profile.vue?vue&type=template&id=57c880a2"
import script from "./BusinessRegulations-Profile.vue?vue&type=script&lang=js"
export * from "./BusinessRegulations-Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports